document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".tabs-slider__item");
  const images = document.querySelectorAll(".tabs-slider__image");

  items.forEach((item, index) => {
    item.addEventListener("mouseenter", () => {
      document
        .querySelector(".tabs-slider__item--active")
        ?.classList.remove("tabs-slider__item--active");
      document
        .querySelector(".tabs-slider__image--active")
        ?.classList.remove("tabs-slider__image--active");

      item.classList.add("tabs-slider__item--active");
      images[index].classList.add("tabs-slider__image--active");
    });
  });
});
